import { FilterAltOutlined } from "@mui/icons-material";
import { Alert, Box, Button, Chip, Collapse, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { exportToExcel } from "../../../../helpers/ExportHelpers";
import DialogChoixFicheEvaluation from "../../fiche_evaluation/DialogChoixFicheEvaluation";
import EvaluationExaminationForm from "../../response/EvaluationExaminationForm";
import MesEquipesFilters from "../components/MesEquipesFilters";
import ValidateEvaluationDialog from "../components/ValidateEvaluationDialog";
import MesEquipesTable, { TEAM_EXPORT_COLUMNS } from "../components/MesEquipesTable";
import useMesEquipes from "../hooks/useMesEquipes";
import { getMesEquipesForExport } from "../services/mesEquipesService";
import { adaptTeamResponse } from "../utils/mesEquipes";

export default function MesEquipesPage() {
  const team = useMesEquipes();
  const [showFilters, setShowFilters] = useState(true);
  const [showStats, setShowStats] = useState(true);
  const [showDirectionStats, setShowDirectionStats] = useState(true);
  const [showTable, setShowTable] = useState(true);
  const [selectedEvaluation, setSelectedEvaluation] = useState(null);
  const [selectedDownload, setSelectedDownload] = useState(null);
  const [selectedValidation, setSelectedValidation] = useState(null);
  const [validationMessage, setValidationMessage] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState("");
  const activeFilters = Number(Boolean(team.filters.direction)) + Number(Boolean(team.filters.service)) + Number(Boolean(team.filters.mot_cle.trim()));
  const title = "Liste de toutes mes équipes";
  const downloadExcel = async () => {
    setIsExporting(true);
    setExportError("");
    try {
      const rows = await getMesEquipesForExport(team.params);
      if (rows.length) exportToExcel(adaptTeamResponse({ data: rows, pagination: { total: rows.length } }).rows,
        TEAM_EXPORT_COLUMNS, "Liste de mes equipes");
    } catch (error) {
      setExportError(error.message);
    } finally { setIsExporting(false); }
  };
  const closeEvaluation = () => { setSelectedEvaluation(null); team.refreshList(); };
  return <>
    {validationMessage && <Alert severity="success" onClose={() => setValidationMessage("")} sx={{ mb: 2 }}>{validationMessage}</Alert>}
    {selectedValidation && <ValidateEvaluationDialog employee={selectedValidation}
      onClose={() => setSelectedValidation(null)} onValidated={(message) => {
        setSelectedValidation(null);
        setValidationMessage(message || "Évaluation validée.");
        team.refreshList();
      }} />}
    {team.error && <Alert severity="error" sx={{ mb: 2 }}>{team.error}</Alert>}
    {exportError && <Alert severity="error" sx={{ mb: 2 }}>{exportError}</Alert>}
    {selectedEvaluation && <EvaluationExaminationForm candidat={selectedEvaluation} isOpen handleClose={closeEvaluation} />}
    {selectedDownload && <DialogChoixFicheEvaluation open onClose={() => setSelectedDownload(null)}
      idCandidat={selectedDownload.user_id} idSaisonActive={selectedDownload.ID_SAISON} />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          bgcolor: "transparent",
          pb: 2,
        }}
      >
        {/* En-tête avec titre et boutons de contrôle */}
        <Box
          sx={{
            px: 2,
            pb: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Typography variant="h6" fontWeight={600} sx={{ color: "#1a73e8" }}>
            {title}
          </Typography>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
            useFlexGap
          >
            {activeFilters > 0 && (
              <Chip
                size="small"
                label={`${activeFilters} filtre${activeFilters > 1 ? "s" : ""}`}
                color="primary"
                variant="outlined"
                sx={{ fontWeight: 500 }}
              />
            )}

            <Tooltip
              title={
                showFilters ? "Masquer les filtres" : "Afficher les filtres"
              }
            >
              <Button
                size="small"
                variant={showFilters ? "outlined" : "text"}
                color="inherit"
                startIcon={<FilterAltOutlined />}
                onClick={() => setShowFilters((v) => !v)}
                sx={{ textTransform: "none" }}
              >
                Filtres
              </Button>
            </Tooltip>

            {/* <Tooltip
              title={showStats ? "Masquer les stats" : "Afficher les stats"}
            >
              <Button
                size="small"
                variant={showStats ? "outlined" : "text"}
                color="inherit"
                startIcon={<InsightsOutlined />}
                onClick={() => setShowStats((v) => !v)}
                sx={{ textTransform: "none" }}
              >
                Statistiques
              </Button>
            </Tooltip>

            <Tooltip
              title={
                showDirectionStats
                  ? "Masquer les stats par direction"
                  : "Afficher les stats par direction"
              }
            >
              <Button
                size="small"
                variant={showDirectionStats ? "outlined" : "text"}
                color="inherit"
                startIcon={<BusinessOutlined />}
                onClick={() => setShowDirectionStats((v) => !v)}
                sx={{ textTransform: "none" }}
              >
                Par direction
              </Button>
            </Tooltip>

            <Tooltip
              title={showTable ? "Masquer le tableau" : "Afficher le tableau"}
            >
              <Button
                size="small"
                variant={showTable ? "outlined" : "text"}
                color="inherit"
                startIcon={
                  showTable ? <VisibilityOffOutlined /> : <VisibilityOutlined />
                }
                onClick={() => setShowTable((v) => !v)}
                sx={{ textTransform: "none" }}
              >
                Tableau
              </Button>
            </Tooltip> */}
          </Stack>
        </Box>

        <MesEquipesFilters showFilters={showFilters} {...team} activeFilters={activeFilters}
          downloadExcel={downloadExcel} isExporting={isExporting} />
        {/* <Collapse in={showStats || showDirectionStats} timeout="auto" unmountOnExit>
          <StatsAndDirectionPanel showStats={showStats} stats={showStats ? team.stats : EMPTY_STATS}
            directions={showDirectionStats ? team.directions : []} loading={team.loading} />
        </Collapse> */}
        <Collapse in={showTable} timeout="auto" unmountOnExit><Box sx={{ mt: 2 }}>
          <MesEquipesTable rows={team.rows} total={team.total} loading={team.loading}
            pagination={team.pagination} onPaginationChange={team.setPagination}
            onEvaluate={setSelectedEvaluation} onDownload={setSelectedDownload}
            onValidate={(row) => { setValidationMessage(""); setSelectedValidation(row); }} />
        </Box></Collapse>
      </Box>
  </>;
}
